export const locale = {
    lang: 'pl',
    data: {
        'Recharge card setup': 'Konfiguracja doładowań',
        'Enabled': 'Włączone',
        'Day of month': 'Dzień miesiąca',
        'Service': 'Usługa',
        'Quantity': 'Ilość',
        'Add item': 'Dodaj',
        'Cancel': 'Anuluj',
        'Save': 'Zapisz',
        'Remove': 'Usuń',
        'Loading': 'Wczytywanie',
    }
};
